module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-3"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }, [_c('em', [_vm._v("Contributors")])])]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  }, [_c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Martin G. Abegg Jr.")]), _vm._v(" Professor of Religious Studies, Trinity Western University, Langley, British Columbia")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("War, Book of")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Samuel L. Adams")]), _vm._v(" Assistant Professor of Old Testament, Union Theological Seminary and Presbyterian School of Christian Education, Richmond, Virginia")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Proverbs, Book of; Qoheleth")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("William Adler")]), _vm._v(" Professor of Early Christianity and Judaism, North Carolina State University, Raleigh, North Carolina")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Chronography; Demetrius the Chronographer")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Patricia Ahearne-Kroll")]), _vm._v(" Assistant Professor of Religion, Ohio Wesleyan University, Delaware, Ohio")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Joseph and Aseneth")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Dale C. Allison Jr.")]), _vm._v(" Errett M. Grable Professor of Early Christianity, Pittsburgh Theological Seminary, Pittsburgh, Pennsylvania")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Abraham, Testament of; Elisha; Kingdom of God")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("David Amit")]), _vm._v(" Deputy Director, Department of Excavations and Surveys, Israel Antiquities Authority, Jerusalem, Israel")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Aqueducts; Cisterns and Reservoirs")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Randal A. Argall")]), _vm._v(" Associate Professor of Religion, Jamestown College, North Dakota")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Persecuted Righteous Person")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Daniel Assefa")]), _vm._v(" Assistant Professor of Sacred Scriptures, Capuchin Franciscan Institute of Philosophy and Theology, Addis Ababa, Ethiopia")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Dreams, Book of (1 Enoch 83–90); Ethiopic")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Kenneth Atkinson")]), _vm._v(" Associate Professor of Religion, University of Northern Iowa, Cedar Falls, Iowa")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Gamla; Masada; Solomon, Psalms of")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Harold W. Attridge")]), _vm._v(" The Reverend Henry L. Black Dean and Lillian Claus Professor of New Testament, Yale Divinity School, New Haven, Connecticut")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Greek Religions")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("David E. Aune")]), _vm._v(" Professor of New Testament, University of Notre Dame, Indiana")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Miracles and Miracle Workers; Prophecy")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Alan J. Avery-Peck")]), _vm._v(" Kraft-Hiatt Professor in Judaic Studies, College of the Holy Cross, Worcester, Massachusetts")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Neusner, Jacob")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Daniel P. Bailey")]), _vm._v(" Adjunct Professor of New Testament and Greek, Northern Seminary, Lombard, Illinois")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Arch of Titus; Atonement; Suffering Servant")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Carol Bakhos")]), _vm._v(" Associate Professor of Near Eastern Languages and Cultures, University of California at Los Angeles")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Midrash, Midrashim")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Elitzur Avraham Bar-Asher")]), _vm._v(" Lecturer, School of Linguistics and Department of the Hebrew Language, The Hebrew University of Jerusalem, Israel")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Hebrew")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("John M. G. Barclay")]), _vm._v(" J. B. Lightfoot Professor of Divinity, University of Durham, England")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Assimilation, Acculturation, Accommodation; Apostasy; Grace; Josephus, Against Apion")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Albert I. Baumgarten")]), _vm._v(" Professor of Jewish History, Bar-Ilan University, Ramat-Gan, Israel")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Bickerman, Elias; Smith, Morton")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("David Bernat")]), _vm._v(" Assistant Professor of Bible, Hebrew College, Newton, Massachusetts")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Adiabene; Circumcision")])])]), _c('p', {
    staticClass: "contrib-para"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_c('strong', [_vm._v("Shani Berrin Tzoref")]), _vm._v(" Lecturer in Hebrew, Jewish, and Biblical Studies, University of Sydney, Australia")])]), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Pesharim")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Jonathan Ben-Dov")]), _vm._v(" Lecturer in Bible, Haifa University, Israel")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Babylonian Culture; Calendars; Mishmarot")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Beth A. Berkowitz")]), _vm._v(" Associate Professor of Talmud and Rabbinics, Jewish Theological Seminary, New York")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Babylonian Talmud")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Katell Berthelot")]), _vm._v(" Chargée de recherche au Centre National pour la Recherche Scientifique, Aix-en-Provence, France; Centre de Recherche Français de Jérusalem, Israel")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("“Early Jewish Literature Written in Greek”; Hecataeus of Abdera; Universalism")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("René S. Bloch")]), _vm._v(" Research Fellow, University of Lausanne, Switzerland")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Orpheus, Pseudo-")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Gideon Bohak")]), _vm._v(" Senior Lecturer in Jewish Philosophy and Religious Studies, Tel Aviv University, Israel")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Amulets; Divination and Magic; Gematria; Gentile Attitudes toward Jews and Judaism; Heliopolis; Oniads")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Marianne Palmer Bonz")]), _vm._v(" Independent Scholar, Plymouth, Massachusetts")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Sardis")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Oded Borowski")]), _vm._v(" Professor of Middle Eastern Studies, Emory University, Atlanta, Georgia")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Agriculture in Palestine")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Alejandro F. Botta")]), _vm._v(" Assistant Professor of Hebrew Bible, Boston University School of Theology, Boston, Massachusetts")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Elephantine, Elephantine Papyri; Sanballat; Slaves, Slavery")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Ra")]), _c('span', {
    staticClass: "awbd"
  }, [_vm._v("ʿ")]), _c('strong', [_vm._v("anan Boustan")]), _vm._v(" Assistant Professor of History, University of California at Los Angeles")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Hekhalot Literature; Ishmael b. Elisha; Yo")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ḥ")]), _c('em', [_vm._v("anan b. Zakkai")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Beverly A. Bow")]), _vm._v(" Assistant Professor of Religious Studies, Cleveland State University, Ohio")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Birth, Miraculous")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("James E. Bowley")]), _vm._v(" Professor of Religious Studies, Millsaps College, Jackson, Mississippi")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Abraham; Apollonius Molon; Aristobulus; Artapanus; Berossus; Cleodemus Malchus; Justus of Tiberius; Nicolaus of Damascus")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Monica Brady")]), _vm._v(" Research Associate, Department of Theology, University of Notre Dame, Indiana")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Prophets, Pseudo-Texts")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("George J. Brooke")]), _vm._v(" Rylands Professor of Biblical Criticism and Exegesis, University of Manchester, England")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Genesis and Exodus, Commentary on (4Q422); Florilegium (4Q174); Genesis Apocryphon; Testimonia (4Q175)")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Magen Broshi")]), _vm._v(" Curator Emeritus, Shrine of the Book, Israel Museum, Jerusalem")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Diet in Palestine")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Joshua Ezra Burns")]), _vm._v(" Assistant Professor of Theology, Marquette University, Milwaukee, Wisconsin")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Conversion and Proselytism; God-fearers")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("David Carr")]), _vm._v(" Professor of Hebrew Bible, Union Theological Seminary, New York")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Literacy and Reading; Pentateuch; Writing")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Mark A. Chancey")]), _vm._v(" Associate Professor of Religious Studies, Southern Methodist University, Dallas, Texas")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Jotapata; Romanization; Sanders, E. P.; Stone Vessels; Temple Tax")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("David W. Chapman")]), _vm._v(" Associate Professor of New Testament and Biblical Archaeology, Covenant Theological Seminary, St. Louis, Missouri")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Family")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("James H. Charlesworth")]), _vm._v(" George L. Collard Professor of New Testament, Princeton Theological Seminary, New Jersey")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Serpent")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Esther G. Chazon")]), _vm._v(" Senior Lecturer in Hebrew Literature, Hebrew University of Jerusalem, Israel")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Words of the Luminaries (4Q181)")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Randall D. Chesnutt")]), _vm._v(" William S. Banowsky Chair in Religion, Pepperdine University, Malibu, California")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Solomon, Wisdom of")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Kelley Coblentz Bautch")]), _vm._v(" Associate Professor of Religious Studies, St. Edward’s University, Austin, Texas")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Geography, Mythic")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Shaye J. D. Cohen")]), _vm._v(" Nathan Littauer Professor of Hebrew Literature and Philosophy, Harvard University, Cambridge, Massachusetts")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Ioudaios; Judaizing; Mishnah; Tosefta; Yavneh")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("John J. Collins")]), _vm._v(" Holmes Professor of Old Testament Criticism and Interpretation, Yale Divinity School, New Haven, Connecticut")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("“Early Judaism in Modern Scholarship”; Apocalypse; Apologetic Literature; Canon; Death and Afterlife; Enoch, Ethiopic Apocalypse of (1 Enoch); Eschatology; Exodus, the; Hecataeus, Pseudo-; Philo the Epic Poet; Tcherikover, Victor (Avigdor)")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Edward M. Cook")]), _vm._v(" Associate Professor of Semitics, Catholic University of America, Washington, D.C.")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Aramaic")])])]), _c('p', {
    staticClass: "contrib-para"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_c('strong', [_vm._v("Mary Rose D’Angelo")]), _vm._v(" Associate Professor of New Testament, University of Notre Dame, Indiana")])]), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Sexuality")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("James R. Davila")]), _vm._v(" Professor of Early Jewish Studies, St. Mary’s College, University of St. Andrews, St. Andrews, Fife, Scotland")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Liturgical Works from Qumran; Pseudepigrapha, Old Testament")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Roland Deines")]), _vm._v(" Professor and Reader in New Testament, University of Nottingham, England")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Pharisees")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Pascale Derron")]), _vm._v(" Librarian, Bibliothèque Cantonale et Universitaire de Lausanne, Switzerland")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Phocylides, Pseudo-")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Devorah Dimant")]), _vm._v(" George and Florence Wise Professor Emerita of Judaism in the Ancient World, University of Haifa, Israel")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Pesher on the Periods (4Q180); Wicked and Holy (4Q181)")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Lorenzo DiTommaso")]), _vm._v(" Associate Professor of Theology, Concordia University, Montréal, Québec")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Daniel, Additions to; Daniel, Book of; Daniel, Pseudo-Texts; Jerusalem, New; New Jerusalem Text; Sibylline Oracles")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Robert Doran")]), _vm._v(" Samuel Williston Professor of Greek and Hebrew, Amherst College, Massachusetts")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Antiochus IV Epiphanes; Eupolemus; Eupolemus, Pseudo-; Thallus; Theodotus")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Henryk Drawnel")]), _vm._v(" Assistant Professor of Old Testament, Catholic University of Lublin, Poland")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Amram, Visions of; Elect of God (4Q534-536); Qahat, Admonitions of")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Jean Duhaime")]), _vm._v(" Professor of Biblical Interpretation, Faculté de Théologie, Université de Montreal, Montréal, Québec")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("War Scroll (1QM)")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("James D. G. Dunn")]), _vm._v(" J. B. Lightfoot Professor of Divinity, Emeritus, University of Durham, England")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Jesus Movement")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Yaron Eliav")]), _vm._v(" Jean and Samuel Frankel Associate Professor of Rabbinic Literature and Jewish History of Late Antiquity, University of Michigan, Ann Arbor, Michigan")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Baths; Medicine and Hygiene")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Peter Enns")]), _vm._v(" Senior Fellow, Biblical Studies, The Biologos Foundation")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Lives of the Prophets")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Tali Erickson-Gini")]), _vm._v(" Archaeological Inspector, Southern Negev District, Israel Antiquities Authority, Jerusalem")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Pottery")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Esther Eshel")]), _vm._v(" Senior Lecturer in Bible, Bar-Ilan University, Ramat-Gan, Israel")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Demons and Exorcism; Genesis Apocryphon; Jonathan the King Text (4Q448); Self-Glorification Hymn")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Hanan Eshel†")]), _vm._v(" Professor of Land of Israel Studies and Archaeology, Bar-Ilan University, Ramat-Gan, Israel")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Bar Kokhba Caves; Bar Kokhba Revolt; Na")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ḥ")]), _c('em', [_vm._v("al")]), _vm._v(" "), _c('span', {
    staticClass: "awit"
  }, [_vm._v("Ḥ")]), _c('em', [_vm._v("ever; Murabba")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ʿ")]), _c('em', [_vm._v("at, Wadi")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Craig A. Evans")]), _vm._v(" Payzant Distinguished Professor of New Testament, Acadia Divinity School, Wolfville, Nova Scotia")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Elders; Joshua, Apocryphon of; Mark, Gospel of; Sanhedrin; Tan")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ḥ")]), _c('em', [_vm._v("umim")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Daniel K. Falk")]), _vm._v(" Associate Professor of Religious Studies, University of Oregon, Eugene")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Festivals and Holy Days; Moses; Moses Texts from Qumran; Rule of Blessings (1QSb); Sabbath")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("David A. Fiensy")]), _vm._v(" Professor of New Testament, Kentucky Christian University, Grayson")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Homily")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Stephen Finlan")]), _vm._v(" Adjunct Professor of Religious Studies, Manhattan College, New York")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Atonement")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Frances Flannery")]), _vm._v(" Associate Professor of Religion, James Madison University, Harrisonburg, Virginia")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Dream and Vision Reports")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Peter W. Flint")]), _vm._v(" Professor of Religious Studies, Trinity Western University, Langley, British Columbia")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Papyri from Qumran Cave 7; Psalm 151; Psalms Scrolls")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Michael F. Fox")]), _vm._v(" Halls-Baxcom Professor of Hebrew Emeritus, University of Wisconsin, Madison, Wisconsin")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Esther, Book of; Esther, Greek Version of")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Steven D. Fraade")]), _vm._v(" Mark Taper Professor of the History of Judaism, Yale University, New Haven, Connecticut")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Targum, Targumim")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Jörg Frey")]), _vm._v(" Professor of New Testament, University of Zurich, Switzerland")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Essenes; Hengel, Martin; Schürer, Emil")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Sean Freyne")]), _vm._v(" Director of Mediterranean and Near Eastern Studies, Emeritus Professor of Theology, Trinity College, Dublin, Ireland")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Galilee; Iturea")])])]), _c('p', {
    staticClass: "contrib-para"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  }, [_c('strong', [_vm._v("Deirdre N. Fulton")]), _vm._v(" Lecturer in Classics and Ancient Mediterranean Studies, Pennsylvania State University, University Park, Pennsylvania")])]), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  }, [_c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Esdras, First Book of; Genealogies")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Katharina Galor")]), _vm._v(" Adjunct Professor of Art History, Rhode Island School of Design and Adjunct Assistant Professor of Judaic Studies, Brown University, Providence, Rhode Island")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Tiberias")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Sandra Gambetti")]), _vm._v(" Associate Professor of History, College of Staten Island, New York")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Diadochi; Ptolemies; Roman Emperors; Seleucids")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Simon Gathercole")]), _vm._v(" Lecturer in New Testament Studies and Fellow, Fitzwilliam College, Cambridge University, England")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Covenantal Nomism; Election; Wisdom (Personified)")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Susan Gelb Rosenberg")]), _vm._v(" Research Fellow in Classics, University of Texas at Austin")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Transjordan")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Gary Gilbert")]), _vm._v(" Associate Professor of Religious Studies, Claremont McKenna College, Claremont, California")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Aphrodisias; Gentiles, Jewish Attitudes toward")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Yonder M. Gillihan")]), _vm._v(" Assistant Professor of Theology, Boston College, Chestnut Hill, Massachusetts "), _c('em', [_vm._v("Associations")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Haim Gitler")]), _vm._v(" Curator of Numismatics, Israel Museum, Jerusalem")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Coins")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Matthew Goff")]), _vm._v(" Associate Professor of Religious Studies, Florida State University, Tallahassee, Florida")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Beatitudes (4QBeatitudes); Instruction (4QInstruction); Wisdom Literature; Wisdom Texts at Qumran")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Robert Goldenberg")]), _vm._v(" Professor of History and Judaic Studies, Stony Brook University, New York")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Pagan Religions")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Roger Good")]), _vm._v(" Editor, Living Stream Ministry, Anaheim, California")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Jacob")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Lester L. Grabbe")]), _vm._v(" Professor of Theology, University of Hull, England")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Babylonians; Mesopotamia, Media, and Babylonia; Parthians; Persian Period; Popular Religion")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("David F. Graf")]), _vm._v(" Professor of Religious Studies, University of Miami, Coral Gables, Florida")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Nabatea")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Deborah A. Green")]), _vm._v(" Greenberg Assistant Professor of Hebrew Language and Literature, University of Oregon, Eugene, Oregon")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Tales of the Persian Court (4Q550)")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Leonard J. Greenspoon")]), _vm._v(" Klutznick Chair in Jewish Civilization, Creighton University, Omaha, Nebraska")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Septuagint")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Bradley C. Gregory")]), _vm._v(" Assistant Professor of Theology and Religious Studies, University of Scranton, Scranton, Pennsylvania")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Wealth and Poverty")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Andrew David Gross")]), _vm._v(" Assistant Professor of Semitic Languages, Catholic University of America, Washington, D.C.")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Oaths and Vows; Temple Scroll (4QTemple)")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Erich S. Gruen")]), _vm._v(" Gladys Rehard Wood Professor of History and Classics, Emeritus, University of California, Berkeley")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("“Judaism in the Diaspora”; Hellenism, Hellenization")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Oren Gutfeld")]), _vm._v(" Lecturer in Archaeology, Institute of Archaeology, Hebrew University of Jerusalem, Israel")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('span', {
    staticClass: "awit"
  }, [_vm._v("ʿ")]), _c('em', [_vm._v("Araq el-Amir; Jericho")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Noah Hacham")]), _vm._v(" Lecturer in Jewish History, Hebrew University of Jerusalem, Israel")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Fasting")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Rachel Hachlili")]), _vm._v(" Professor of Archaeology, University of Haifa, Israel")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Architecture; Art; Burial Practices")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Gideon Hadas")]), _vm._v(" Director, Ein Gedi Oasis Excavations, Kibbutz Ein Gedi, Israel")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('span', {
    staticClass: "awit"
  }, [_vm._v("ʿ")]), _c('em', [_vm._v("Ein Gedi")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Robert G. Hall")]), _vm._v(" Elliot Professor of Religion, Hampden-Sydney College, Virginia")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Isaiah, Ascension of")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Betsy Halpern-Amaru")]), _vm._v(" Professor Emerita of Religion, Vassar College, Poughkeepsie, New York")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Judith, Book of; Land, Concept of")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Daniel C. Harlow")]), _vm._v(" Professor of Religion, Calvin College, Grand Rapids, Michigan")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("“Early Judaism and Early Christianity”; Abraham, Apocalypse of; Ascent to Heaven; Baruch, Third Book of; Demons and Exorcism; Fortresses and Palaces; Joseph, Prayer of; Messianic Apocalypse (4Q521); Phoenix")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Daniel J. Harrington, S.J.")]), _vm._v(" Professor of New Testament, Boston College, Chestnut Hill, Massachusetts")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Apocrypha; Baruch, First Book of; Ethics; Jeremiah, Letter of; Maccabean Revolt; Paul")])])]), _c('p', {
    staticClass: "contrib-para"
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xii"
    }
  }, [_c('strong', [_vm._v("Hannah K. Harrington")]), _vm._v(" Professor of Old Testament, Patten University, Oakland, California")])]), _c('a', {
    attrs: {
      "id": "page_xii"
    }
  }, [_c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Holiness; Purity and Impurity; Sin; Tohorot")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Charlotte Hempel")]), _vm._v(" Birmingham Fellow, Department of Theology and Religion, University of Birmingham, England")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Damascus Document")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("David Henshke")]), _vm._v(" Professor of Talmud, Bar-Ilan University, Ramat-Gan, Israel")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Tithing")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Matthias Henze")]), _vm._v(" Watt J. and Lilly G. Jackson Associate Professor of Biblical Studies, Rice University, Houston, Texas")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Baruch, Second Book of; Nebuchadnezzar; Syriac")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Jens Herzer")]), _vm._v(" Professor of New Testament Exegesis and Theology, University of Leipzig, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Baruch, Fourth Book of")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Karina Martin Hogan")]), _vm._v(" Assistant Professor of Theology, Fordham University, New York")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Ezra, Fourth Book of")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Anders Hultgård")]), _vm._v(" Professor Emeritus of the History of Religions, University of Uppsala, Sweden")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Persian Religion")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Larry W. Hurtado")]), _vm._v(" Professor of New Testament Language, Literature, and Theology, School of Divinity, New College, University of Edinburgh, Scotland")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Mediator Figures; Monotheism")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Tal Ilan")]), _vm._v(" Professor of Jewish Studies, Institut für Judaistik, Freie Universität, Berlin, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Women")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("David Instone-Brewer")]), _vm._v(" Research Fellow, Tyndale House, Cambridge, England")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Marriage and Divorce")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Matt Jackson-McCabe")]), _vm._v(" Associate Professor of Religious Studies, Niagara University, New York")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("James, Epistle of; Jude, Epistle of; Peter, Epistles of")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Naomi Jacobs")]), _vm._v(" Postdoctoral Fellow in Hebrew Bible and Biblical Hebrew, Washington University in St. Louis, Missouri")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Tobit, Book of")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Sara Raup Johnson")]), _vm._v(" Associate Professor of Classics, University of Connecticut, Hartford")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Court Tales; Maccabees, Third Book of; Novels")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Jutta Jokiranta")]), _vm._v(" Lecturer in Old Testament, University of Helsinki, Finland")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Sectarianism")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Christine E. Joynes")]), _vm._v(" Associate Director, Centre for Reception History of the Bible, University of Oxford, England")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Elijah")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Richard Lee Kalmin")]), _vm._v(" Theodore R. Racoosin Professor of Rabbinic Literature, Jewish Theological Seminary, New York")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Rabbis")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("John I. Kampen")]), _vm._v(" Academic Dean and Professor of New Testament, Methodist Theological School in Ohio, Delaware, Ohio")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Hasideans")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Ranon Katzoff")]), _vm._v(" Professor of Classical Studies and General History, Bar-Ilan University, Ramat-Gan, Israel")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Babatha Archive; Contracts from the Judean Desert")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Allen Kerkeslager")]), _vm._v(" Associate Professor of New Testament, Saint Joseph’s University, Philadelphia, Pennsylvania")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Athletics; Cyprus; Cyrenaica; Gymnasium")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Angela Kim Harkins")]), _vm._v(" Assistant Professor of Religious Studies, Fairfield University, Connecticut")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Hymns, Prayers, and Psalms")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Michael A. Knibb")]), _vm._v(" Samuel Davidson Professor Emeritus of Old Testament Studies, King’s College London, England")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Enoch, Similitudes of (1 Enoch 37–71)")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("James L. Kugel")]), _vm._v(" Professor of Bible and Director, Institute for the History of the Jewish Bible, Bar-Ilan University, Ramat-Gan, Israel")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("“Early Jewish Biblical Interpretation”")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Robert A. Kugler")]), _vm._v(" Paul S. Wright Professor of Christian Studies, Lewis and Clark College, Portland, Oregon")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Aaron; Dead Sea Scrolls; Herakleopolis Papyri; Levi; Naphtali, Testament of (4Q215); Priests; Testaments")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("David A. Lambert")]), _vm._v(" Assistant Professor of Religious Studies, University of North Carolina, Chapel Hill, North Carolina")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Repentance")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Jonathan D. Lawrence")]), _vm._v(" Associate Professor of Religious Studies and Theology, Canisius College, Buffalo, New York")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Washing, Ritual")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Kyong-Jin Lee")]), _vm._v(" Assistant Professor of Biblical Studies, Spring Arbor University, Spring Arbor, Michigan")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Almsgiving; Righteousness/Justice")])])]), _c('p', {
    staticClass: "contrib-para"
  }, [_c('a', {
    attrs: {
      "id": "page_xii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }, [_c('strong', [_vm._v("Mary J. W. Leith")]), _vm._v(" Associate Professor of Religious Studies, Stonehill College, Easton, Massachusetts")])]), _c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }, [_c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Seals and Seal Impressions; Daliyeh, Wadi ed-")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Tracy Lemos")]), _vm._v(" Assistant Professor of Hebrew Bible, Rhodes College, Memphis, Tennessee")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Intermarriage")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Jutta Leonhardt-Balzer")]), _vm._v(" Lecturer in New Testament, King’s College, University of Aberdeen, Scotland")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Dualism")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Dan Levene")]), _vm._v(" Senior Lecturer in History, University of Southampton, United Kingdom")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Magic Bowls and Incantations")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Lee I. Levine")]), _vm._v(" Professor of Jewish History and Archaeology, Institute of Archaeology, Hebrew University of Jerusalem, Israel")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Caesarea Maritima; Jerusalem; Synagogues; Temple")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("John R. Levison")]), _vm._v(" Professor of New Testament, Seattle Pacific University School of Theology, West Seattle, Washington")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Adam and Eve; Spirit, Holy")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Bert Jan Lietaert Peerbolte")]), _vm._v(" Professor of New Testament, University of Amsterdam, The Netherlands")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Antichrist")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Timothy H. Lim")]), _vm._v(" Professor of Hebrew Bible and Second Temple Judaism, New College, University of Edinburgh, Scotland")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Multilingualism")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("James M. Lindenberger")]), _vm._v(" Professor of Hebrew Bible, Vancouver School of Theology, British Columbia")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Letters")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Marilyn J. Lundberg")]), _vm._v(" Associate Director, West Semitic Research Project, Rolling Hills Estates, California")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Leviticus Targum (4Q156); Paleo-Hebrew Scrolls")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Daniel A. Machiela")]), _vm._v(" Assistant Professor of Religious Studies, McMaster University, Hamilton, Ontario")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Babel, Tower of; Flood; Noah")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Jodi Magness")]), _vm._v(" Kenan Distinguished Professor for Teaching Excellence in Early Judaism, University of North Carolina at Chapel Hill, North Carolina")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('span', {
    staticClass: "awit"
  }, [_vm._v("ʿ")]), _c('em', [_vm._v("Ein Feshka; Qumran")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Christl E. Maier")]), _vm._v(" University Professor of Old Testament, Philipps-Universität Marburg, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Ruth, Book of; Song of Songs")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Paul Mandel")]), _vm._v(" Lecturer in Hebrew and Comparative Literature, University of Haifa, Israel")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Hillel; Shammai")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Adam Marshak")]), _vm._v(" Lecturer in Classical Studies, Gann Academy, Waltham, Massachusetts")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("“Jewish History from Pompey to Hadrian”; Fortresses and Palaces; Herod the Great; Herodian Dynasty; Idumea")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("John W. Marshall")]), _vm._v(" Associate Professor of Religion, University of Toronto, Ontario")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Revelation, Book of")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Eric Mason")]), _vm._v(" Associate Professor of Biblical Studies, Judson University, Elgin, Illinois")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Hebrews, Epistle to the; Melchizedek Scroll (11Q13)")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Steve Mason")]), _vm._v(" Professor of Humanities & Ancient History and Canada Research Chair in Cultural Identity and Interaction, York University, Toronto, Ontario")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Josephus; Josephus, Jewish Antiquities")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Byron R. McCane")]), _vm._v(" Albert C. Outler Professor of Religion, Wofford College, Spartanburg, South Carolina")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Miqva")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ʾ")]), _c('em', [_vm._v("ot; Ossuaries")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Carmel McCarthy")]), _vm._v(" Professor Emerita of Hebrew and Syriac, University College Dublin, Ireland")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Peshi")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ṭ")]), _c('em', [_vm._v("ta")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("James S. McClaren")]), _vm._v(" Senior Lecturer in Theology, Australian Catholic University, Fitzroy, Victoria")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Imperial Cult, Jews and the; Josephus, Jewish War; Resistance Movements")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Steven L. McKenzie")]), _vm._v(" Professor of Hebrew Bible, Rhodes College, Memphis, Tennessee")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Deuteronomistic History")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Doron Mendels")]), _vm._v(" Max and Sophie Mydans Professor of Humanities, Hebrew University of Jerusalem, Israel")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Alexander Polyhistor; Historiography")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Sarianna Metso")]), _vm._v(" Professor of Hebrew Bible, University of Toronto at Mississauga, Ontario")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Rule of the Community (1QS + Fragments)")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("David P. Moessner")]), _vm._v(" Professor of Biblical Theology, University of Dubuque Theological Seminary, Iowa")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Luke-Acts")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("David G. Monaco")]), _vm._v(" Ph.D. Candidate, University of Chicago Divinity, Chicago, Illinois")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Menander, Sentences of the Syriac")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Stewart Moore")]), _vm._v(" Ph.D. Candidate in Religious Studies, Yale University, New Haven, Connecticut")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Moore, George Foote")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Frederick J. Murphy")]), _vm._v(" Professor of Religious Studies, College of the Holy Cross, Worcester, Massachusetts")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Biblical Antiquities (Pseudo-Philo)")])])]), _c('p', {
    staticClass: "contrib-para"
  }, [_c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }, [_c('strong', [_vm._v("Hindy Najman")]), _vm._v(" Associate Professor of Jewish Studies, University of Toronto, Ontario")])]), _c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }, [_c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Decalogue; Torah and Tradition")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Gordon D. Newby")]), _vm._v(" Professor and Chair, Department of Middle Eastern and South Asian Studies, Emory University, Atlanta, Georgia")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Arabian Peninsula")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Judith H. Newman")]), _vm._v(" Associate Professor of Old Testament, Emmanuel College, University of Toronto, Ontario")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Psalms, Book of; Worship")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Carol A. Newsom")]), _vm._v(" C. H. Candler Professor of Old Testament, Candler School of Theology, Emory University, Atlanta, Georgia")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Job, Book of; Songs of the Sabbath Sacrifice; Theodicy")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("George W. E. Nickelsburg")]), _vm._v(" Daniel J. Krumm Professor Emeritus of New Testament, University of Iowa, Iowa City")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Charles, Robert Henry; Resurrection; Son of Man")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Maren Niehoff")]), _vm._v(" Senior Lecturer in Jewish Thought, Hebrew University of Jerusalem, Israel")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Joseph; Philo, Allegorical Commentary; Philo, Exposition of the Law")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Bilhah Nitzan")]), _vm._v(" Associate Professor of Hebrew Culture, Tel Aviv University, Israel")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Berakhot (4Q286-290)")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Brent Nongbri")]), _vm._v(" Postdoctoral Fellow in Classics, Macquarie University, New South Wales, Australia")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Bousset, Wilhelm; Greek Authors on Jews and Judaism")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("David Noy")]), _vm._v(" Lecturer in Classics, University of Wales, Lampeter Ceredigion, United Kingdom")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Alexander the Great; Egypt; Papyri")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Gerbern S. Oegema")]), _vm._v(" Professor of Religious Studies, McGill University, Montréal, Québec")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Creation; Zephaniah, Apocalypse of")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Saul M. Olyan")]), _vm._v(" Professor of Religious and Judaic Studies, Brown University, Providence, Rhode Island")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Sacrifices and Offerings")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Aharon Oppenheimer")]), _vm._v(" Professor of Jewish History, Tel Aviv University, Israel")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("People of the Land")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Andrei Orlov")]), _vm._v(" Associate Professor of Theology, Marquette University, Milwaukee, Wisconsin")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Enoch; Enoch, Slavonic Apocalypse of (2 Enoch); Melchizedek; Metatron; Slavonic")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("J. Andrew Overman")]), _vm._v(" Professor of Classics, Macalester College, St. Paul, Minnesota")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Matthew, Gospel of")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Alexander Panayotov")]), _vm._v(" Leverholme Postdoctoral Research Fellow, School of Divinity, University of St. Andrews, Scotland")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Greece and the Aegean")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Donald W. Parry")]), _vm._v(" Abraham O. Smoot Professor of Hebrew Bible, Brigham Young University, Provo, Utah")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Isaiah Scrolls")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Joseph Patrich")]), _vm._v(" Professor of Archaeology, Institute of Archaeology, Hebrew University of Jerusalem, Israel")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Entertainment Structures; Samaria-Sebaste")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Michael Peppard")]), _vm._v(" Assistant Professor of Theology, Fordham University, New York, New York")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Music")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Dorothy M. Peters")]), _vm._v(" Assistant Professor of Biblical Studies, Trinity Western University, Langley, British Columbia")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Joseph, Apocryphon of (4Q371 and 4Q342)")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Jean-Pierre Pettorelli")]), _vm._v(" Independent Scholar, Port-Louis, France")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Adam and Eve, Life of")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Stephen J. Pfann")]), _vm._v(" President, University of the Holy Land, Jerusalem, Israel")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Scripts and Scribal Practices")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("D. Nathan Phinney")]), _vm._v(" Associate Professor of Biblical Studies, Malone College, Canton, Ohio")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Ezekiel, Book of")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Michele Piccirillo†")]), _vm._v(" Professor of Archaeology, Biblical Geography and History, Studium Biblicum Franciscarum, Jerusalem, Israel")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Mosaics")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Chad Pierce")]), _vm._v(" Assistant Professor of New Testament, Central College, Pella, Iowa")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Satan and Related Figures")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Kenneth E. Pomykala")]), _vm._v(" Professor of Religion, Calvin College, Grand Rapids, Michigan")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Catenae (4Q177, 4Q182); David; David Apocryphon; Judah; Kingship; Messianism")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Mladen Popović")]), _vm._v(" Director, Qumran Institute, University of Groningen, The Netherlands")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Astronomy and Astrology; Determinism; Horoscopes;")]), _vm._v(" "), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ʾ")]), _c('em', [_vm._v("Otot; Sun and Moon")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Jonathan J. Price")]), _vm._v(" Professor of Classics and Ancient History, Tel Aviv University, Israel")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Revolt, First Jewish")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Miriam Pucci Ben Zeev")]), _vm._v(" Professor of Jewish History, Ben Gurion University, Beersheva, Israel")])]), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }, [_c('em', [_vm._v("“Jews among Greeks and Romans”; Diaspora Uprisings")])]), _c('a', {
    attrs: {
      "id": "page_xv"
    }
  }, [_c('em', [_vm._v("(116-117 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C.E.")]), _vm._v("); Manetho; Rights of Jews in the Roman World")])])]), _c('a', {
    attrs: {
      "id": "page_xv"
    }
  }, [_c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Reinhard Pummer")]), _vm._v(" Professor of Religious Studies, Ottawa University, Ottawa, Ontario")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Gerizim, Mount; Samaria; Samaritan Pentateuch; Samaritanism")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Rebecca Raphael")]), _vm._v(" Assistant Professor of Religious Studies, Texas State University, San Marcos, Texas")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Healing; Sickness and Disease")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Uriel Rappaport")]), _vm._v(" Professor of Jewish History, University of Haifa, Israel")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Judas Maccabaeus; Maccabees, First Book of")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Annette Yoshiko Reed")]), _vm._v(" Assistant Professor of Religious Studies, University of Pennsylvania, Philadelphia")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Fallen Angels; Jewish Christianity; Job, Testament of; Parting of the Ways")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("John C. Reeves")]), _vm._v(" Blumenthal Professor of Judaic Studies, University of North Carolina at Charlotte")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Enosh; Giants; Gnosticism; Seth")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Eyal Regev")]), _vm._v(" Senior Lecturer, Land of Israel Studies and Archaeology, Bar-Ilan University, Ramat-Gan, Israel")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Boethusians")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Adele Reinhartz")]), _vm._v(" Associate Vice-President of Research, University of Ottawa, Ontario")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("John, Gospel of")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Benjamin E. Reynolds")]), _vm._v(" Honorary Research Fellow in Divinity and Religious Studies, University of Aberdeen, Scotland")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Faith/Faithfulness")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("James N. Rhodes")]), _vm._v(" Visiting Assistant Professor of Religious Studies, Saint Michael’s College, Colchester, Vermont")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Adversus Judaeos Literature; Allegory")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Jason Ripley")]), _vm._v(" Assistant Professor of Religion, St. Olaf College, Northfield, Minnesota")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Aqedah; Isaac")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Deborah W. Rooke")]), _vm._v(" Lecturer in Old Testament Studies, King’s College London, England "), _c('em', [_vm._v("Joshua (Jeshua), the High Priest; Zadokites")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Renate Rosenthal-Heginbotton")]), _vm._v(" Independent Scholar, Grossolt, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Jewelry")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("David Rothstein")]), _vm._v(" Assistant Professor of Bible, Bar-Ilan University, Ramat-Gan, Israel")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Phylacteries and Mezuzot")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Christopher Rowland")]), _vm._v(" Dean Ireland’s Professor of the Exegesis of Holy Scripture, Queen’s College, University of Oxford, England")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Apocalypticism")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("David T. Runia")]), _vm._v(" Master of Queen’s College and Professorial Fellow, University of Melbourne, Australia")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Philo, Questions and Answers on Genesis and Exodus")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Leonard V. Rutgers")]), _vm._v(" Professor of Late Antiquity, Institute of History, Utrecht University, The Netherlands")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Catacombs; Rome")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("E. P. Sanders")]), _vm._v(" Arts and Sciences Professor of Religion Emeritus, Duke University, Durham, North Carolina")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Jesus of Nazareth")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Joachim Schaper")]), _vm._v(" Reader in Old Testament, University of Aberdeen, Scotland")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Levites")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Lawrence H. Schiffman")]), _vm._v(" Ethel and Irvin A. Edelman Professor of Hebrew and Judaic Studies, New York University")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("“Early Judaism and Rabbinic Judaism”")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Alison Schofield")]), _vm._v(" Assistant Professor of Hebrew Bible and Judaic Studies, University of Denver, Colorado")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Exile; Wilderness")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Eileen M. Schuller")]), _vm._v(" Professor of Religious Studies, McMaster University, Hamilton, Ontario")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Hodayot (1QH and Related Texts); Psalms, Apocryphal")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Daniel R. Schwartz")]), _vm._v(" Professor of the History of the Jewish People, Hebrew University, Jerusalem")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Tobiads; Maccabees, Second Book of")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Joshua J. Schwartz")]), _vm._v(" Professor of Historical Geography of Ancient Israel, Bar-Ilan University, Ramat-Gan, Israel")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Judea; Pilgrimage")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Adiel Schremer")]), _vm._v(" Professor of Jewish History, Bar-Ilan University, Ramat-Gan, Israel")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Celibacy")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Steven Schweitzer")]), _vm._v(" Academic Dean and Associate Professor of Old Testament, Bethany Theological Seminary, Richmond, Indiana")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Chronicles, Books of; Cyrus the Great; Sheshbezzar; Tobiah; Zerubbabel")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("James M. Scott")]), _vm._v(" Professor of Religious Studies, Trinity Western University, Langley, British Columbia")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Covenant; Restoration")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Judith Lynn Sebesta")]), _vm._v(" Professor of Classics, University of South Dakota, Vermillion, South Dakota")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Clothing and Dress")])])]), _c('p', {
    staticClass: "contrib-para"
  }, [_c('a', {
    attrs: {
      "id": "page_xv"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xvi"
    }
  }, [_c('strong', [_vm._v("David Rolph Seely")]), _vm._v(" Professor of Ancient Scripture, Brigham Young University, Provo, Utah")])]), _c('a', {
    attrs: {
      "id": "page_xvi"
    }
  }, [_c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Barki Nafshi (4Q434-438)")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Chris Seeman")]), _vm._v(" Assistant Professor of Religion, Coe College, Cedar Rapids, Iowa")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("“Jewish History from Alexander to Pompey”; Phoenicia")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Alan F. Segal")]), _vm._v(" Professor of Religion and Ingeborg Rennert Professor of Jewish Studies, Barnard College, Columbia University, New York")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Mysticism")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Arthur Segal")]), _vm._v(" Professor of Archaeology, Zimman Institute of Archaeology, University of Haifa, Israel")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Decapolis; Theaters")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Michael Segal")]), _vm._v(" Senior Lecturer in Bible, Hebrew University of Jerusalem, Israel")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Jubilees, Book of")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Alexei Sievertsev")]), _vm._v(" Assistant Professor of Religious Studies, DePaul University, Chicago, Illinois")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Family Religion")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Carolyn Sharp")]), _vm._v(" Associate Professor of Old Testament, Yale Divinity School, New Haven, Connecticut")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Jeremiah and Lamentations")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Israel Shatzman")]), _vm._v(" Professor of History, Hebrew University of Jerusalem, Israel")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Military, Jews in")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Aharon Shemesh")]), _vm._v(" Professor of Talmud, Bar-Ilan University, Ramat-Gan, Israel")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Legal Texts; Ordinances (4QOrdinances)")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Joseph Sievers")]), _vm._v(" Professor of Jewish History and Literature in the Hellenistic Period, Pontifical Biblical Institute, Rome, Italy")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Hasmoneans")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Dennis E. Smith")]), _vm._v(" Professor of New Testament, Philipps Theological Seminary, Tulsa, Oklahoma")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Meals")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Daniel L. Smith-Christopher")]), _vm._v(" Professor of Old Testament, Loyola Marymount University, Los Angeles, California")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Ezra, Book of; Nehemiah, Book of; Peace")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Benjamin D. Sommer")]), _vm._v(" Professor of Bible, Jewish Theological Seminary, New York")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Isaiah, Book of")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Günter Stemberger")]), _vm._v(" Professor of Jewish Studies Emeritus, Institut für Jüdaistik, University of Vienna, Austria")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Sadducees")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Gregory E. Sterling")]), _vm._v(" Professor of Theology, University of Notre Dame, Indiana")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Philo, Apologetic Treatises")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Ryan Stokes")]), _vm._v(" Ph.D. Candidate in Religious Studies, Yale University, New Haven, Connecticut")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Belial; Evil; Sons of God; Watchers, Book of the (1 Enoch 1–36)")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Michael E. Stone")]), _vm._v(" Gail Levin de Nur Professor of Religious Studies and Professor of Armenian Studies, Hebrew University of Jerusalem, Israel "), _c('em', [_vm._v("Aramaic Levi Document; Armenian")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("James F. Strange")]), _vm._v(" Distinguished University Professor, University of South Florida, Tampa")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Sepphoris")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Loren T. Stuckenbruck")]), _vm._v(" Richard J. Dearborn Professor of New Testament, Princeton Theological Seminary, New Jersey")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("“Apocrypha and Pseudepigrapha”; Enoch, Epistle of (1 Enoch 91–108); Giants, Book of")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("David W. Suter")]), _vm._v(" Professor of Religious Studies, Saint Martin’s University, Lacey, Washington")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Hermon, Mount; Paneion")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Marvin A. Sweeney")]), _vm._v(" Professor of Hebrew Bible, Claremont School of Theology and Graduate University School of Religion, California")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Minor Prophets")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Joan E. Taylor")]), _vm._v(" Adjunct Senior Lecturer, University of Waikato, New Zealand")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("John the Baptist; Therapeutae")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("D. Andrew Teeter")]), _vm._v(" Assistant Professor of Hebrew Bible, Harvard Divinity School, Cambridge, Massachusetts")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Scribes and Scribalism")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Eibert Tigchelaar")]), _vm._v(" Research Professor, Faculty of Theology, Katholieke Universiteit, Leuven, Belgium")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("“The Dead Sea Scrolls”; Job Targum (4Q157, 11Q10)")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Samuel Thomas")]), _vm._v(" Assistant Professor of Religion, California Lutheran University, Thousand Oaks")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Goodenough, Erwin Ramsdell; Mystery; Mystery Religion, Judaism as")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Thomas H. Tobin, S.J.")]), _vm._v(" Professor of Theology, Loyola University, Chicago, Illinois")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Logos")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Pablo A. Torijano")]), _vm._v(" Associate Professor of Hebrew Philosophy, Universidad Complutense de Madrid, Spain")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Solomon; Solomon, Testament of")])])]), _c('p', {
    staticClass: "contrib-para"
  }, [_c('a', {
    attrs: {
      "id": "page_xvi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }, [_c('strong', [_vm._v("Paul Trebilco")]), _vm._v(" Professor of New Testament Studies, University of Otago, Dunedin, New Zealand")])]), _c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }, [_c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Antioch (Pisidian); Asia Minor")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Julio Trebolle Barrera")]), _vm._v(" Professor of Hebrew and Aramaic Studies and Director, Instituto de Ciencias de las Religiones, Universidad Complutense, Madrid, Spain")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Latin Versions of the Hebrew Bible")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Johannes Tromp")]), _vm._v(" Professor of the History and Literature of Early Judaism, Leiden University, The Netherlands")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Cain and Abel; Idols and Images; Latin; Moses, Assumption of")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Fabian E. Udoh")]), _vm._v(" Visiting Professor of New Testament, McGill University, Montréal, Québec")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Economics; Tribute and Taxes")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Eugene Ulrich")]), _vm._v(" John A. O’Brien Professor of Hebrew Scriptures, University of Notre Dame, Indiana")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("“The Jewish Scriptures: Texts, Versions, Canons”")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Jan Willem van Henten")]), _vm._v(" Professor of New Testament, Hellenistic-Jewish, and Early Christian Literature, University of Amsterdam, The Netherlands")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Maccabees, Fourth Book of; Martyrdom")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Jacques van Ruiten")]), _vm._v(" Senior Lecturer in Old Testament and Early Jewish Studies, University of Groningen, The Netherlands")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Garden of Eden — Paradise")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Annewies van den Hoek")]), _vm._v(" Lecturer in Greek and Latin, Harvard Divinity School, Cambridge, Massachusetts")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Philo, Philosophical Works")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Pieter W. van der Horst")]), _vm._v(" Professor of Early Judaism and Ancient Christianity, Universiteit Utrecht, The Netherlands")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Ezekiel the Tragedian; Greek; Inscriptions")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("James C. VanderKam")]), _vm._v(" John A. O’Brien Professor of Hebrew Bible, University of Notre Dame, Indiana")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("“Judaism in the Land of Israel”; Enoch, Astronomical Book of (1 Enoch 72–82); High Priests")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Marjorie Venit")]), _vm._v(" Professor of Art History and Archaeology, University of Maryland, College Park, Maryland")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Alexandria")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Benedict Thomas Viviano, O.P.")]), _vm._v(" Professor of New Testament, University of Fribourg, Switzerland")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Education")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Hanne von Weissenberg")]), _vm._v(" Lecturer in Biblical Studies, University of Helsinki, Finland")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Miq")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ṣ")]), _c('em', [_vm._v("at Ma")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ʿ")]), _c('em', [_vm._v("a")]), _c('span', {
    staticClass: "awit"
  }, [_vm._v("ś")]), _c('em', [_vm._v("ê ha-Torah")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Rodney A. Werline")]), _vm._v(" Senior Minister, First Christian Church, Greensboro, North Carolina")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Manasseh, Prayer of; Penitential Prayer")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Steven Weitzmann")]), _vm._v(" Professor of Jewish Studies, Stanford University, California")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Copper Scroll (3Q15); Violence")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("L. Michael White")]), _vm._v(" Ronald Nelson Smith Chair in Classics and Director, Institute for the Study of Antiquity and Christian Origins, University of Texas at Austin")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Ostia")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Sidnie White Crawford")]), _vm._v(" Professor of Hebrew Bible, University of Nebraska, Lincoln")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Reworked Pentateuch (4QRP)")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("K. William Whitney, Jr.")]), _vm._v(" Independent Scholar, Arlington, Massachusetts")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Behemoth; Leviathan")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Margaret H. Williams")]), _vm._v(" Research Fellow in Classical Studies, The Open University, Milton Keynes, England")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Julius Caesar, Gaius; Latin Authors on Jews and Judaism; Roman Generals; Roman Governors")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Lawrence M. Wills")]), _vm._v(" Ethelbert Talbot Professor of Biblical Studies, Episcopal Divinity School, Cambridge, Massachusetts")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Asceticism")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("David Winston")]), _vm._v(" Professor Emeritus of Hellenistic and Judaic Studies, Graduate Theological Union, Berkeley, California")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Greek Philosophy; Wolfson, Harry Austryn")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Michael O. Wise")]), _vm._v(" Professor of Hebrew Bible and Ancient Languages, Northwestern College, St. Paul, Minnesota")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Archives and Libraries; Bar Kokhba Letters; Crucifixion")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Archie Wright")]), _vm._v(" Associate Professor of Biblical Studies, Regent University, Virginia Beach, Virginia")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Angels; Michael, the Archangel")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Benjamin G. Wright III")]), _vm._v(" Professor of Religious Studies, Lehigh University, Bethlehem, Pennsylvania")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Aristeas, Letter of; Ben Sira, Book of")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("J. Edward Wright")]), _vm._v(" Professor of Hebrew Bible and Early Judaism, University of Arizona, Tucson")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Cosmology; Heaven; Stars")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Jed D. Wyrick")]), _vm._v(" Associate Professor of Religious Studies, California State University, Chico")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Animal Worship; Pseudepigraphy")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Geza Xeravits")]), _vm._v(" Professor of Bible, Sapientia Theological College, Budapest, Hungary")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Rule of the Congregation (1Q28a); Son of God")])])]), _c('p', {
    staticClass: "contrib-para"
  }, [_c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xviii"
    }
  }, [_c('strong', [_vm._v("Azzan Yadin")]), _vm._v(" Associate Professor of Jewish Studies, Rutgers University, New Brunswick, New Jersey")])]), _c('a', {
    attrs: {
      "id": "page_xviii"
    }
  }, [_c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Akiba (Aqiva)")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Adela Yarbro Collins")]), _vm._v(" Buckingham Professor of New Testament Criticism and Interpretation, Yale Divinity School, New Haven, Connecticut")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Blasphemy")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Kent L. Yinger")]), _vm._v(" Associate Professor of New Testament, George Fox University, Newberg, Oregon "), _c('em', [_vm._v("Judgment")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Molly Zahn")]), _vm._v(" Lecturer, Religious Studies, University of Kansas, Lawrence, Kansas")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Text Types, Hebrew")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Jürgen K. Zangenberg")]), _vm._v(" Professor of New Testament Exegesis and Early Christian Literature, Leiden University, The Netherlands")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("“Archaeology, Papyri, and Inscriptions”")])]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para"
  }, [_c('strong', [_vm._v("Magnus Zetterholm")]), _vm._v(" Adjunct Associate Professor of Culture and Communication, Linköping University, Sweden")]), _vm._v(" "), _c('p', {
    staticClass: "contrib-para1"
  }, [_c('em', [_vm._v("Antioch (Syrian); Damascus; Syria")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a3f4e94","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/008_Contributors.vue
// module id = 78
// module chunks = 0